import { render, staticRenderFns } from "./vistaCliente.vue?vue&type=template&id=6b7e3011&scoped=true&"
import script from "./vistaCliente.vue?vue&type=script&lang=js&"
export * from "./vistaCliente.vue?vue&type=script&lang=js&"
import style0 from "./vistaCliente.vue?vue&type=style&index=0&id=6b7e3011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e3011",
  null
  
)

export default component.exports